import { useFetch } from '@/composables/useFetch'
import type { EventInterface } from '@/interfaces/Interfaces'
export const useEventStore = defineStore('eventStore', () => {
  const apps = ref([])
  const languages = ref([])
  const mainLanguage = ref(null)
  const route = useRoute()
  const event = ref({} as EventInterface)
  const personaCustomerRoles = ref([])
  const invoiceOptions = ref([])
  const eventOptions = ref([])

  watch(event, () => {
    if (
      !Array.isArray(event) &&
      event.value &&
      typeof event.value === 'object' &&
      Object.keys(event.value).length > 0
    ) {
      if (event.value.apps) {
        apps.value = event.value.apps.map(element => element.name)
      }
      languages.value = event.value?.languages ?? []
      mainLanguage.value = event.value?.default_language ?? 'es'
      retrieveInvoiceOptions()
      retrieveEventOptions()
    }
  })

  const retrieve = async (event_id = null) => {
    const { data, promise } = useFetch(`/api/v1/events/${event_id ?? route.params.event_id}`)
    await promise
    event.value = data.value.data
    return Promise.resolve()
  }

  const retrieveRoles = async () => {
    if (event.value && event.value.customer_id) {
      const { data, promise } = useFetch(`/api/v1/roles/persona/customer/${event.value.customer_id}/true`)
      await promise
      personaCustomerRoles.value = data.value.data
      return Promise.resolve()
    }
  }

  const retrieveInvoiceOptions = async () => {
    if (event.value && event.value.id) {
      const { data, promise } = useFetch(`/api/v1/events/${event.value.id}/invoice-options`)
      await promise
      if (data.value && data.value.data) {
        invoiceOptions.value = data.value.data
      }
      return Promise.resolve()
    }
  }

  const retrieveEventOptions = async () => {
      if (event.value && event.value.id) {
          const { data, promise } = useFetch(`/api/v1/events/${event.value.id}/eventoptions`)
          await promise
          if (data.value && data.value.data) {
              console.log("DATAAAA", data.value.data)
              eventOptions.value = data.value.data
          }
          return Promise.resolve()
      }
  }

  const getId = () => {
    return event.value?.id ?? null
  }

  const getName = () => {
    return event.value?.name ?? null
  }

  const getCustomerId = () => {
    return event.value.customer_id ?? null
  }

  const getMainLanguage = () => {
    return mainLanguage.value
  }

  const getLanguages = () => {
    return languages.value
  }

  const getLanguagesISOCode = () => {
    return languages.value.map(element => element.iso_code)
  }

  const hasApp = name => {
    if (Array.isArray(name)) {
      return name.some(item => apps.value.includes(item))
    } else {
      return apps.value.includes(name)
    }
  }

  const getLanguageName = iso_code => {
    const matchingLanguages = languages.value.filter(element => {
      if (element.iso_code === iso_code) {
        return element.description
      }
    })

    if (!matchingLanguages.length) return ''

    return matchingLanguages.pop().description
  }

  const $reset = () => {
    event.value = {}
    apps.value = []
    languages.value = []
    mainLanguage.value = null
    personaCustomerRoles.value = []
    invoiceOptions.value = []
  }

  return {
    event,
    apps,
    personaCustomerRoles,
    languages,
    mainLanguage,
    invoiceOptions,
    eventOptions,
    retrieve,
    $reset,
    getId,
    getName,
    getCustomerId,
    hasApp,
    getMainLanguage,
    getLanguages,
    getLanguagesISOCode,
    getLanguageName,
    retrieveRoles,
    retrieveInvoiceOptions,
  }
})
